import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';

const DialogComponent = ({ open, handleClose, title, description, children }) => (
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title" style={{paddingBottom: 0}}>{title}</DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
                {description}
            </DialogContentText>
            {children}
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} autoFocus variant="outlined" color="primary">
                Close
            </Button>
        </DialogActions>
    </Dialog>
);

export default DialogComponent;